import './index.scss';
import React, { useEffect } from 'react'; //,{ useState, useEffect, useRef, useContext }
import { Card } from 'antd-mobile';
// import moment from 'moment';
// import { getUser } from '../../../../../utils';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';

function CARDS(props) {
  const { type } = props;
  const getOption = (cardlist) => {
    let number = 0;
    // eslint-disable-next-line no-unused-vars
    let value1 = 0;
    // eslint-disable-next-line no-unused-vars
    let value2 = 0;
    let name1 = '';
    let name2 = '';
    let title = '';
    if (type === 'sup-rate') {
      number = setRate(cardlist.bddnum, cardlist.kcnum);
      value1 = cardlist.bddnum * 1;
      value2 = cardlist.kcnum - cardlist.bddnum;
      name1 = '督导率';
      name2 = '未督导率';
      title = '督导率';
    } else {
      number = setRate(cardlist.hgnum, cardlist.kcnum);
      value1 = cardlist.hgnum * 1;
      value2 = cardlist.kcnum - cardlist.hgnum;
      name1 = '合格率';
      name2 = '不合格率';
      title = '合格率';
    }

    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)',
      },
      color: number * 100 > 50 ? ['#42AB44', '#E2F6E2'] : ['#FF881B', '#F6EBE2'],
      series: [
        {
          name: title,
          type: 'pie',
          center: ['50%', '50%'], // 饼图的圆心坐标
          radius: ['50%', '60%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            //  饼图图形上的文本标签
            normal: {
              // normal 是图形在默认状态下的样式
              show: true,
              position: 'center',
              fontWeight: 'bold',
              formatter: ' {a|{d}%}\n{b|{b}}', // {b}:数据名； {c}：数据值； {d}：百分比，可以自定义显示内容，
              rich: {
                a: {
                  color: number * 100 > 50 ? '#5DB75F' : '#FF922E',
                  padding: [0, 10],
                  fontSize: 20,
                },
                b: {
                  color: '#666666',
                  padding: [5, 10, 0, 10],
                  fontSize: 10,
                },
              },
            },
          },

          labelLine: {
            normal: {
              show: false,
            },
          },
          data: [
            {
              value: (number * 100).toFixed(2),
              name: name1,
              label: {
                normal: {
                  show: true,
                },
              },
            },
            {
              value: (100 - number * 100).toFixed(2),
              name: name2,
              label: {
                normal: {
                  show: false,
                },
              },
              // tooltip: {
              //   show:false,
              // }
            },
          ],
        },
      ],
    };
  };

  //去除小数
  const ceilNumber = (str) => {
    // let st = '' + str;
    let num = Math.round(str);
    return num;
  };

  // 平均分
  const setAverage = (sumscore, bddnum) => {
    let numone = ceilNumber(sumscore);
    let numtwo = ceilNumber(bddnum);
    if (!numone || !numtwo) return 0;
    return (numone / numtwo).toFixed(1);
  };
  // 达标率
  const setRate = (hgnum, kcnum) => {
    let numone = ceilNumber(hgnum);
    let numtwo = ceilNumber(kcnum);
    if (!numone || !numtwo) return 0;
    return numone / numtwo;
  };

  useEffect(() => {
    // console.log('cardlist', cardlist)
  }, []);
  const { title, cardlist, img } = props;
  return (
    <div style={{ width: '100%' }}>
      {/* <WingBlank size="lg"> */}
      {/* <WhiteSpace size="lg" /> */}
      <Card>
        <Card.Header
          title={<div className="cardtit">{title || cardlist.dictValue}</div>}
          thumb={img}
          thumbStyle={{ width: '4vw' }}
        />
        <Card.Body>
          <div className="cardcont">
            <div className="cardleft">
              <p>课程总数：{cardlist.kcnum || 0}</p>
              <p>异常课程：{cardlist.ycnum || 0}</p>
              <p>被督导的课程：{cardlist.bddnum || 0}</p>
              <p>被督导老师：{cardlist.bddjsnum || 0}</p>
              <p>平均得分：{setAverage(cardlist.sumscore, cardlist.bddnum) || 0}</p>
            </div>
            <div className="cardright">
              <ReactEchartsCore
                echarts={echarts}
                notMerge={true}
                lazyUpdate={true}
                style={{ width: '45vw', height: '45vw' }}
                option={getOption(cardlist)}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      {/* <WhiteSpace size="lg" /> */}
      {/* </WingBlank> */}
    </div>
  );
}

export default CARDS;
